import { render, staticRenderFns } from "./EventCoreInfo.vue?vue&type=template&id=551397f2&"
import script from "./EventCoreInfo.vue?vue&type=script&lang=js&"
export * from "./EventCoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./EventCoreInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports